<template>
    <!--帮助中心  -->
    <div class="support">
      <!-- vip海报图 -->
			<!-- <div class="vip-view-style-forever-bg">
				<img :src="'https://yousubao.oss-cn-shenzhen.aliyuncs.com/static/index/huiyuan_fwzx_img@2x.png' "  style="width: calc(100% - 48px);height: 300px;" mode="aspectFill"/>
			</div> -->
			<!-- <div class="vip-view-style-content-line"></div> -->
<!-- 会员 -->
  <div class="member">
        <!-- 当用户未充值会员（identityType < 3）时显示 -->
        <div class="mask" v-if="userInfo && userInfo.identityType < 3">
          <div class="left">
            <div class="title">激活会员</div>
            <div class="open">
              开通会员，享受超级权限，查看全网供应，采购信息等。
            </div>
          </div>
        </div>
        <!-- 当用户充值了优塑会员（假设新的定义范围）时显示 -->
        <div class="mask" v-else-if="userInfo && (userInfo.identityType === 3)">
          <div class="left">
            <div class="title">尊敬的优塑会员</div>
            <div class="open">
              享受超期权限 查看全网供应 采购信息等  会员截止时间  :    {{ userInfo.vipTakeEffectTime.split(" ")[0] }} - {{ userInfo.vipLoseEfficacyTime.split(" ")[0] }}
            </div>
          </div>
        </div>
        <!-- 当用户充值了优企会员（包含 identityType 为 4）时显示 -->
        <div class="mask" v-else-if="userInfo && (userInfo.identityType === 4 || userInfo.identityType === 5 || userInfo.identityType === 6)">
          <div class="left">
            <div class="title">尊敬的优企会员</div>
            <div class="open">
              享受超期权限 查看全网供应 采购信息等  会员截止时间:{{ userInfo.vipTakeEffectTime.split(" ")[0] }} - {{ userInfo.vipLoseEfficacyTime.split(" ")[0] }}
            </div>
          </div>
        </div>
		</div>
      <div class="vip-view-style-content">
				<div class="vip-view-style-content-item"  v-for="(item, index) in dataList" :key="index"  @click.stop="vipChange(index,item.id,item.price)" :class="{'vip-view-style-content-item-active': cellIndex == index}">
					<div class="vip-view-style-content-item-xianshi" v-show="item.membershipTips!=''">{{item.membershipTips}}</div>
					<div class="vip-view-style-content-item-cel">
						<div class="vip-view-style-content-item-cel-month">{{item.membershipDays }}{{ filterName(item.companyDays) }} </div>
						<div class="vip-view-style-content-item-cel-price"><span style="font-size: 29px;">￥</span>{{ item.price /100 }}</div>
						<div class="vip-view-style-content-item-cel-month">{{item.membershipName }} </div>
					</div>
				</div>
			</div>

			<div class="pay-style-forever-content-forever">
				<!-- <div style="width: 100%; height: auto;">					
					<div class="pay-style-forever-content-forever-title">支付方式</div>
					<div class="pay-style-forever-content-forever-item">
						<div class="pay-style-forever-content-forever-item-btn" @click.stop="payType = 1" :class="{'pay-style-forever-content-forever-item-btn-active': payType == 1}" v-if="!ios_status">
							<div class="pay-style-forever-content-forever-item-btn-icon">
								<img :src="'https://yousubao.oss-cn-shenzhen.aliyuncs.com/static/index/huiyuan_weixin_icon@2x.png'"/>
							</div>
							<div class="pay-style-forever-content-forever-item-btn-title">微信支付</div>
						</div>
					</div>
				</div> -->
				<!-- <div	class="pay-style-foreve-btn" @click.stop="openChange">立即支付</div> -->
				<!-- <div class="pay-style-foreve-totast">
					<div class="pay-style-foreve-totast-name">购买须知:</div>
					<div class="pay-style-foreve-totast-icon" @click.stop="options_status = !options_status">
						<img :src="'https://yousubao.oss-cn-shenzhen.aliyuncs.com/static/index/' + (options_status ? 'danxuankuang_icon@2x.png' : 'danxuankuang_icon_nor.png')"/>
					</div>
					<div class="pay-style-foreve-totast-title">我已阅读并同意<span style="color: #E1B461;" @click="openUrls">《会员服务协议》</span></div>
				</div> -->
			</div>

      <div class="support_title">会员服务说明<span class="support_title2">(服务咨询、申请开通服务或服务续费事项请联系在线客服)</span></div>
      <!-- <div style="font-size: 15px;text-align: left;" v-html="content"></div> -->
      <!-- 平台合作 -->
      <!-- <div class="platform" v-if="lianxi_status">
        <div class="connect">扫描下方二维码添加微信</div>
        <div class="wechat" :key="item">
          <img :src="qrcode | urlLoad" alt="" class="image" />
        </div>
      </div> -->
     <el-dialog
      title="《会员服务协议》"
      :visible.sync="yuedu"
      width="5.71rem"
      center
      class="openDialog button"
    > 
     <div style="font-size: 15px;text-align: left;" v-html="aboutText"></div> 
		</el-dialog>
    <!-- </el-dialog>
     <el-dialog
      title="会员收费二维码"
      :visible.sync="chargeDialog"
      width="5.71rem"
      center
      class="chargeDialog button"
      @close="handleClosePay"
    >
      <img :src="this.codeUrl | urlLoad" id="qrcode" alt="" />
      <p>支付过程中请不要关闭!</p>
    </el-dialog> -->

    <div class="member-service">
      <div class="service-cards">
        <div class="service-card">
          <div class="card-title">普通会员</div>
          <div class="card-content">
            <div class="card-item">1、企业商铺 公司简介宣传视频产品展示电子名片</div>
            <div class="card-item">2、可有限查看所有供应信息和企业详情</div>
            <div class="card-item">3、可有限查看国内价格行情历史价格物性参数功能</div>
            <div class="card-item">4、有限发布原料 改性再生助剂机械的供应产品信息</div>
            <div class="card-item">5、排列供应商库查看行业资讯,市场分析关注店铺功能</div>
          </div>
        </div>
        
        <div class="service-card">
          <div class="card-title">优塑会员</div>
          <div class="card-content">
            <div class="card-item">1、包含(普通会员)拥有的权限名片</div>
            <div class="card-item">2、浏览查看所有供应信息采购信息按打电话询价试样申请</div>
            <div class="card-item">3、无限发布供应信息 采购信息原料现货期货报价</div>
            <div class="card-item">4、查看最新行情价格 走势图 历史价格物性参</div>
            <div class="card-item">5、名片推送修端工厂</div>
          </div>
        </div>
        
        <div class="service-card">
          <div class="card-title">优企会员</div>
          <div class="card-content">
            <div class="card-item">1、包含(优塑会员)享受的全部权限</div>
            <div class="card-item">2、首页特权位(优选品牌和优企供应商分类展示</div>
            <div class="card-item">3、专属客服一对一推荐服务</div>
            <div class="card-item">4、应信息专类排列优先</div>
            <div class="card-item">5、匹配相对应采购信息优先推送</div>
          </div>
        </div>

				<div class="service-card">
					<div class="price-display">{{price/100}}</div>
					<img :src="this.codeUrl | urlLoad" id="qrcode" alt="" />
					<div class="pay">请扫码完成支付</div>
					<div @click="openUrls" class="pay pays">《会员服务协议》</div>
				</div>
      </div>
    </div>

    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        codeUrl:'',
        chargeDialog:false,
        dataList: [
		
				],
        yuedu:false,
        vipId:0,
        cellIndex:0,
        options_status: false,
        identityList:
             {
               365: "年",
               30: "个月",
               1 : "天"		  
            },
        tableData: [{
            date: '2016-05-02',
            name: '王小虎',
            address: '上海市普陀区金沙江路 1518 弄'
          }, {
            date: '2016-05-04',
            name: '王小虎',
            address: '上海市普陀区金沙江路 1517 弄'
          }, {
            date: '2016-05-01',
            name: '王小虎',
            address: '上海市普陀区金沙江路 1519 弄'
          }, {
            date: '2016-05-03',
            name: '王小虎',
            address: '上海市普陀区金沙江路 1516 弄'
          }],
          qrcode: "",
          lianxi_status: true,
          content: "",
          aboutText:"",
          timer: null,
          userInfo:null,
          orderId:"",
					hasSupplierInformation:0,
					price:0,
					payStatus: false
      };
    },
    async created() {
      await this.getUserInfo()
      this.membershipPackageList()
      this.connectServices()
      // this.textProtocol()
      await this.getAboutText()
    },
    methods: {
             /**
     * @descripttion: 监听支付弹窗关闭
     */
      handleClosePay() {
        if (this.timer) {
          clearInterval(this.timer)
        }
      },
     async getUserInfo() {
       try {
         let res = await this.$apiFun.getUserInfo();
         console.log("后端返回的用户信息:", res.result); 
         this.userInfo = res.result;
         this.hasSupplierInformation = res.result.hasSupplierInformation;
         console.log("当前用户的会员类型:", this.userInfo.identityType);
       } catch (error) {
         console.error('获取用户信息失败:', error);
         this.$message.error('获取用户信息失败，请稍后重试');
       }
     },
      async handleReportPayNotify() {
        let params = {
          orderIdOrSN: this.orderId,
        };
				await   this.$apiFun.GetSaoPayStatus(params).then(res => {
          if (res.result) {
            clearInterval(this.timer);
            this.$message.success("支付成功");
            this.payStatus = true;
            this.getUserInfo();
          }
        }).catch(err => {
          console.error('支付状态检查失败:', err);
        });
     },
     async  openChange() {
        if (this.hasSupplierInformation == 0) {
          this.$message({
            type: "error",
            message: "当前您还没入驻供应商，请先入驻供应商",
            duration: 1500,

          });
          return;
        }

        let params = {
          orderIdOrSN: this.vipId,
          payType: "WXNATIVE",
          tradeType: "NATIVE",
        };
				await this.$apiFun.openMember(params).then(res => {
          this.codeUrl = res.result.fileName;
          this.orderId = res.result.outTradeNo;
          
          if (this.timer) {
            clearInterval(this.timer);
          }
          
          this.timer = setInterval(this.handleReportPayNotify, 1000);
        }).catch(err => {
          console.error('生成支付二维码失败:', err);
        });
      },
         openUrls(){
           this.yuedu = true;
         },
         async getAboutText(){
           let res = await this.$apiFun.aboutText(1);
           this.aboutText = res.result.privacyPolicy
         },
         textProtocol() {
          let res =  this.$apiFun.textProtocol(1);
          this.content = res.result.rightsAndInterests
        },
        // 联系客服
       connectServices() {
          let params = {};
          let res =  this.$apiFun.connectServices(params);
          // this.supportList = res.result.rows;
          if (res.code == 200) {
            this.qrcode = res.result.customerServiceQrCode;
          }
        },	
        // 会员套餐列表
				async  membershipPackageList() {
          await this.$apiFun.membershipPackageList().then(res => {
            this.dataList = res.result.rows
            //默认获取第一个套餐
            this.vipId = res.result.rows[0].id
						this.price = res.result.rows[0].price
          })
          this.openChange()
        },
        vipChange(index,id,price){
          this.cellIndex = index
          this.vipId = id
					this.price = price
          this.openChange()
        },
       filterName(row) {
          return this.identityList[row];
			}
    },
    beforeDestroy() {
      if (this.timer) {
        clearInterval(this.timer);
      }
    }
  };
  </script>
  
 <style lang="less" scoped>
   // 定义全局变量，方便统一管理颜色、字体等样式
   @primary-color: #E1BE7D;
   @secondary-color: #6E4C2B;
   @text-color: #333;
   @light-text-color: #666;
   @background-color: #f9f5f0;
   @card-bg-color: #fff;
   @card-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
   @card-hover-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
   @font-family: 'Open Sans', sans-serif;
 
 
   // 支付弹窗样式
   .chargeDialog {
     /deep/ .el-dialog__body {
       display: flex;
       flex-direction: column;
       align-items: center;
       padding: 20px;
       .qrcode,
       #qrcode {
         width: 180px;
         height: 180px;
         margin-bottom: 15px;
       }
       span {
         font-size: 16px;
         font-weight: 400;
         color: @text-color;
         line-height: 1.5;
         text-align: center;
       }
       .text {
         display: flex;
         flex-direction: column;
         align-items: center;
       }
     }
   }
 .info_message {
             margin-top: 0.1rem;
             font-size: 0.18rem;
             font-weight: 400;
             color: #333333;
           }
   // 主容器样式
   .member {
     width: 100%;
     height: 1rem;
     background: url(../../assets/account/bg_lxrxx@2x.png) no-repeat;
     background-size: 100% 100%;
	margin-top: -0.2rem;
     //margin-bottom: 0.2rem;
   
     .mask {
       width: 100%;
       height: 100%;
       display: flex;
       justify-content: space-evenly;
       align-items: center;
       .left {
         width: 6.618rem;
         // height: 100%;
         text-align: left;
         font-family: Microsoft YaHei;
   
         .title {
        font-size: 0.23rem;
        font-weight: bold;
        color: #654932;
		position: absolute;
		margin-left: -2rem;
		margin-top:0.1rem;
         }
         .open {
        font-size: 0.16rem;
        font-weight: 500;
		line-height: 0.3rem;
        color: #654932;
		margin-top: 0.4rem;
		margin-left: -2rem;
         }
       }
     }
   }
   .support {
      padding: 40px;
         background: @background-color;
         box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);
         border-radius: 20px;
         font-family: @font-family;
         display: inline-block; 
 
     // VIP 海报背景样式
     .vip-view-style-forever-bg {
       width: 100%;
       height: auto;
       background-position: center center;
       background-size: cover;
       background-repeat: no-repeat;
       border-radius: 10px;
       overflow: hidden;
     }
 
     // VIP 内容分隔线样式
     .vip-view-style-content-line {
       width: 100%;
       height: 1px;
       background: #e0e0e0;
       margin: 20px 0;
     }
 
     // VIP 套餐内容样式
     .vip-view-style-content {
       width: 100%;
       height: auto;
       display: flex;
       justify-content: space-between;
       gap: 30px;
       padding: 20px 0;
 
       // VIP 套餐项样式
       .vip-view-style-content-item {
         flex: 1;
         min-height: 200px;
         background: @card-bg-color;
         border-radius: 15px;
         border: 2px solid transparent;
         position: relative;
         cursor: pointer;
         transition: all 0.3s ease;
         box-shadow: @card-shadow;
 
         &:hover {
           transform: translateY(-5px);
           box-shadow: @card-hover-shadow;
           border-color: @primary-color;
         }
 
         // VIP 套餐限时提示样式
         .vip-view-style-content-item-xianshi {
           width: auto;
           height: auto;
           padding: 8px 15px;
           background: #BC875D;
           border-radius: 8px 0 8px 0;
           font-family: @font-family;
           font-weight: 500;
           font-size: 20px;
           color: #fff;
           display: inline-block;
           text-align: center;
           position: absolute;
           top: -10px;
           right: -10px;
         }
 
         // VIP 套餐内容详情样式
         .vip-view-style-content-item-cel {
            height: 100%;
               display: flex;
               flex-direction: column;
               justify-content: center;
               align-items: center;
               padding: 5px;
               gap: 8px;
 
           // VIP 套餐时长样式
           .vip-view-style-content-item-cel-month {
             font-size: 18px;
             color: @secondary-color;
             font-weight: 600;
	text-align: center;
           }
 
           // VIP 套餐价格样式
           .vip-view-style-content-item-cel-price {
             color: @primary-color;
             font-size: 0.3rem;
             font-weight: 700;
		text-align: center;
 
             span {
               font-size: 20px !important;
               margin-right: 4px;
             }
           }
 
           // VIP 套餐名称样式
           .vip-view-style-content-item-cel-month {
             font-size: 0.3rem;
             color: @secondary-color;
             font-weight: 600;
           }
         }
       }
 
       // 激活的 VIP 套餐项样式
       .vip-view-style-content-item-active {
         background: @card-bg-color;
         border: 2px solid @primary-color;
       }
     }
 
     // 支付相关内容样式
     .pay-style-forever-content-forever {
       width: 100%;
       height: auto;
       padding: 20px 0;
       display: flex;
       flex-direction: column;
       align-items: center;
       gap: 15px;
 
       // 支付方式标题样式
       .pay-style-forever-content-forever-title {
         width: auto;
         height: auto;
         font-family: @font-family;
         font-weight: 600;
         font-size: 16px;
         color: @text-color;
       }
 
       // 支付方式选项样式
       .pay-style-forever-content-forever-item {
         width: auto;
         height: auto;
         display: flex;
         justify-content: center;
         gap: 20px;
 
         // 支付方式按钮样式
         .pay-style-forever-content-forever-item-btn {
           width: 150px;
           height: 60px;
           background: @card-bg-color;
           border-radius: 10px;
           border: 2px solid #e0e0e0;
           display: flex;
           justify-content: center;
           align-items: center;
           cursor: pointer;
           transition: all 0.3s ease;
 
           &:hover {
             border-color: @primary-color;
           }
 
           // 支付方式图标样式
           .pay-style-forever-content-forever-item-btn-icon {
             width: 30px;
             height: 30px;
             display: flex;
             align-self: center;
             margin-right: 10px;
           }
 
           // 支付方式标题样式
           .pay-style-forever-content-forever-item-btn-title {
             width: auto;
             height: auto;
             font-family: @font-family;
             font-weight: 400;
             font-size: 14px;
             color: @text-color;
           }
         }
 
         // 激活的支付方式按钮样式
         .pay-style-forever-content-forever-item-btn-active {
           border: 2px solid @primary-color!important;
         }
       }
 
       // 立即支付按钮样式
       .pay-style-foreve-btn {
         width: 200px;
         height: 50px;
         background: linear-gradient(90deg, @primary-color 0%, #e0b25c 100%);
         border-radius: 25px;
         font-family: @font-family;
         font-weight: 700;
         font-size: 18px;
         color: #fff;
         display: flex;
         justify-content: center;
         align-items: center;
         cursor: pointer;
         transition: all 0.3s ease;
 
         &:hover {
           transform: scale(1.05);
         }
       }
 
       // 购买须知样式
       .pay-style-foreve-totast {
         width: auto;
         height: auto;
         display: flex;
         justify-content: center;
         align-items: center;
         gap: 10px;
 
         // 购买须知名称样式
         .pay-style-foreve-totast-name {
           width: auto;
           height: auto;
           font-family: @font-family;
           font-weight: 400;
           font-size: 14px;
           color: @light-text-color;
         }
 
         // 购买须知勾选图标样式
         .pay-style-foreve-totast-icon {
           width: 20px;
           height: 20px;
           display: flex;
           align-self: center;
           cursor: pointer;
         }
 
         // 购买须知标题样式
         .pay-style-foreve-totast-title {
           width: auto;
           height: auto;
           font-family: @font-family;
           font-weight: 400;
           font-size: 14px;
           color: @light-text-color;
 
           span {
             color: @primary-color;
             cursor: pointer;
             text-decoration: underline;
           }
         }
       }
     }
 
     // 会员服务说明标题样式
     .support_title {
		position: absolute;
       text-align: left;
       font-size: 24px;
       font-weight: 700;
       color: @text-color;
	margin-top: -30px;
       display: flex;
       align-items: center;
 
       // 会员服务说明副标题样式
       .support_title2 {
         color: @light-text-color;
         font-size: 16px;
         margin-left: 15px;
       }
     }
 
     // 会员服务内容样式
     .support_content {
       text-align: left;
       font-size: 16px;
       font-weight: 400;
       color: @text-color;
       margin-top: 20px;
       cursor: pointer;
       transition: all 0.3s ease;
 
       &:hover {
         color: @primary-color;
       }
     }
 
     // 分页样式
     .el-pagination {
       position: relative;
       top: 0;
       text-align: left;
       margin-top: 30px;
       display: flex;
       justify-content: center;
 
       /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
         background-color: @primary-color;
         color: #fff;
       }
     }
 
     // 账户 VIP 列表样式
     .account-vip-list {
       width: 100%;
       height: auto;
       padding: 20px;
       display: flex;
       background: #f5f5f5;
       margin-top: 30px;
       border-radius: 10px;
 
       // 账户 VIP 列表名称样式
       .account-vip-list-name {
         width: auto;
         height: auto;
         font-family: @font-family;
         font-weight: 700;
         font-size: 16px;
         color: @primary-color;
         display: flex;
         align-self: center;
       }
 
       // 账户 VIP 列表其他信息样式
       .account-vip-list-flex {
         width: auto;
         height: auto;
         display: flex;
         align-self: center;
         margin-left: 30px;
         gap: 20px;
 
         // 账户 VIP 列表信息名称样式
         .account-vip-list-flex-name {
           width: auto;
           height: auto;
           font-family: @font-family;
           font-weight: 400;
           font-size: 14px;
           color: @text-color;
           display: flex;
           align-self: center;
         }
 
         // 账户 VIP 列表信息图标样式
         .account-vip-list-flex-icon {
           width: 20px;
           height: 20px;
           display: flex;
           align-self: center;
           cursor: pointer;
           transition: all 0.3s ease;
 
           &:hover {
             transform: scale(1.1);
           }
         }
       }
     }
 
     // 平台合作样式
     .platform {
       margin-top: 40px;
       font-family: @font-family;
 
       // 平台合作连接提示样式
       .connect {
         font-size: 18px;
         font-family: @font-family;
         font-weight: 600;
         color: @text-color;
         margin-bottom: 20px;
         text-align: center;
       }
 
       // 平台合作微信二维码样式
       .wechat {
         display: flex;
         flex-direction: column;
         align-items: center;
         font-size: 16px;
         font-family: @font-family;
         font-weight: 400;
         color: @text-color;
         line-height: 1.5;
 
         .image {
           width: 200px;
           height: 200px;
           margin: 0 0 20px 0;
           border-radius: 10px;
         }
       }
     }
 
     // 会员服务样式
     .member-service {
       margin: 40px 0;
       padding: 0 15px;
 
       // 会员服务标题样式
       .service-title {
         background: @primary-color;
         color: #fff;
         font-size: 20px;
         padding: 10px 20px;
         border-radius: 0 0 20px 0;
         display: inline-block;
         margin-bottom: 20px;
       }
 
       // 会员服务卡片样式
       .service-cards {
         display: flex;
         justify-content: space-between;
         margin-top: 20px;
         gap: 30px;
 
         // 会员服务卡片项样式
         .service-card {
			width: 2.6rem;
           flex: 1;
           background: @card-bg-color;
           border-radius: 15px;
           padding: 15px;
           border: 1px solid #e0e0e0;
           transition: all 0.3s ease;
           box-shadow: @card-shadow;
           // 会员服务卡片标题样式
           .card-title {
             color: @secondary-color;
             font-size:0.28rem;
             font-weight: 600;
             text-align: center;
             margin-bottom: 20px;
           }
 
           // 会员服务卡片内容样式
           .card-content {
			width: 100%;
			height: auto;
             .card-item {
               text-align: left;
               color: @light-text-color;
               font-size: 0.2rem;
               line-height: 1.5;
               margin-bottom: 2px;
               position: relative;
             }
           }
 
           // 会员服务卡片价格显示样式
           .price-display {
             margin-top: 20px;
             margin-bottom: 10px;
             font-size: 30px;
             font-weight: 700;
             color: #ff4500;
 
             &::before {
               content: "¥";
               font-size: 30px;
               margin-right: 4px;
             }
           }
 
           // 会员服务卡片支付提示样式
           .pay {
             font-size: 16px;
             margin-top: 5px;
             color: @text-color;
           }
 
           // 会员服务卡片协议链接样式
           .pays {
             color: @primary-color;
             cursor: pointer;
             transition: all 0.3s ease;
 
             &:hover {
               color: #b59052;
               text-decoration: underline;
             }
           }
 
           // 会员服务卡片二维码样式
           #qrcode {
             width: 180px;
			height: 180px;
			margin: 20px 0;
			border-radius: 10px;
			}
			}
			}
			}
			}
			</style>